import React, { useEffect } from "react";
import cookie from "react-cookies";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "pages/Home";
import MapSearch from "pages/MapSearch";
import AdminDashBoard from "pages/Dashboard/AdminDashboard/";
import OrganizationDashboard from "pages/Dashboard/OrganizationDashboard/";
import SuperuserDashboard from "pages/Dashboard/SuperuserDashboard/";
import UserDashboard from "pages/Dashboard/UserDashboard/";
import ResourceView from "pages/Resource/ViewResource";
import CreateResource from "pages/Resource/CreateResource";
import CreateAd from "pages/Ad/CreateAd";
import CreateAccount from "pages/Account/CreateAccount";
import SignUp from "pages/SignUp";
import NotFound from "pages/NotFound";
import "style/tailwind.css";
import "style/pagination.css";
import { setAuthToken } from "utils/axios";

const App = () => {
  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken");
    setAuthToken(accessToken);
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        rtl={false}
        draggable
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/search/:name" element={<MapSearch />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/dashboard" element={<AdminDashBoard />} />
        <Route path="/superuser-dashboard" element={<SuperuserDashboard />} />
        <Route
          path="/organization/:orgName"
          element={<OrganizationDashboard />}
        />
        <Route path="/profile/:tokenId" element={<UserDashboard />} />
        <Route path="/view-resource" element={<ResourceView />} />
        <Route path="/create-resource" element={<CreateResource />} />
        <Route path="/create-ad" element={<CreateAd />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
